import { Behaviour, serializable } from "@needle-tools/engine";

export class WheelRotation extends Behaviour {
    
    @serializable()
    public rotateSpeed : number = 0.1;
    
    start(): void {
        console.log("WheelRotation start");
    }

    update() {
        this.gameObject.rotateX(this.context.time.deltaTime * this.rotateSpeed);
      }
}